<ng-container *transloco="let t">
  @if (displayEventAnnotation() && !disableEventAnnotation()) {
    <div class="flex min-w-0 flex-1 gap-x-3">
      <IMultiSelectMenu
        [value]="selectedEventAnnotationTypes()"
        (valueChange)="selectEventAnnotationTypes($event)"
        popoverWidth="400"
        withSelectOnly
        [(searchQuery)]="queryFilterAnnotationTypes"
      >
        <ISelectTrigger>
          <ISelectValue [placeholder]="t('dashboard.select_activites_tooltip')">
            <div *iSelectValue="let value" class="flex items-center gap-1.5">
              {{ selectedEventAnnotationTypes()[0].label }}
              <span class="text-gray-500">
                {{
                  selectedEventAnnotationTypes().length > 1
                    ? " (+" + (selectedEventAnnotationTypes().length - 1) + ")"
                    : ""
                }}
              </span>
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          <ISelectOption [selectAllOption]="true" />
          <IDropdownMenuSeparator />
          @for (option of filteredEventAnnotationTypes(); track option.value) {
            <ISelectOption [value]="option">
              {{ option.label }}
            </ISelectOption>
          }
        </ISelectContent>
      </IMultiSelectMenu>

      <IMultiSelectMenu
        [value]="selectedStrategies()"
        (valueChange)="selectStrategies($event)"
        popoverWidth="400"
        withSelectOnly
        [(searchQuery)]="queryFilterStrategies"
      >
        <ISelectTrigger>
          <ISelectValue [placeholder]="t('overview.select_strategy')">
            <div *iSelectValue="let value" class="flex items-center gap-1.5">
              {{ selectedStrategies()[0].label }}
              <span class="text-gray-500">
                {{ selectedStrategies().length > 1 ? " (+" + (selectedStrategies().length - 1) + ")" : "" }}
              </span>
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          <ISelectOption [selectAllOption]="true" />
          <IDropdownMenuSeparator />
          @for (option of filteredStrategies(); track option.value) {
            <ISelectOption [value]="option">
              {{ option.label }}
            </ISelectOption>
          }
        </ISelectContent>
      </IMultiSelectMenu>
    </div>
  }
</ng-container>
